export const adminLoginButtonMetaData = {
    isRepeatable: false
}
